import React from "react";
import classnames from "classnames";
import { parse } from "qs";
import { BaseLayout } from "components";
import { isIOS } from "utils";
import { linkConfig, brandNames } from "config";
import styles from "./styles.module.scss";
import WeixinMask from "./components/WeixinMask";

// channel 值對應的二級品牌 key
const CHANNEL_BRAND_MAP = {
  "wwjy-ios": "wwjy",
  "wszt-ios": "wszt",
};

const BRAND_LOGO_MAP = {
  wasin: "/download/logo.png",
  wwjy: "/download/logo-wwjy.jpg",
  wszt: "/download/logo-wszt.jpg",
};

class Download extends React.PureComponent {
  state = {
    brandKey: "wasin", // 一級品牌 (wasin)； "wwjy" / "wszt" = 二級品牌
    iosUrl: linkConfig.download.ios.wwjy,
    androidUrl: "",
    loading: false,
    title: "立即下载",
  };

  componentDidMount() {
    const searchParams = parse(window.location.search.slice(1));
    this.setState({
      ...this.resolveBrandFromChannel(searchParams),
      ...this.resolveAndroidApkByUtmSource(searchParams),
    });
  }

  resolveBrandFromChannel = ({ channel }) => {
    const brandKey = CHANNEL_BRAND_MAP[channel && channel.toLowerCase()];
    if (!brandKey) return {};

    return {
      brandKey,
      iosUrl: linkConfig.download.ios[brandKey],
    };
  };

  resolveAndroidApkByUtmSource = ({ utm_source }) => {
    let androidUrl = linkConfig.download.android.global || "";

    if (utm_source) {
      const src = utm_source.toLowerCase();
      if (src.includes("sms")) {
        androidUrl = linkConfig.download.android.sms || "";
      } else if (src.includes("tuijian")) {
        androidUrl = linkConfig.download.android.tuijian || "";
      } else if (src.includes("gw")) {
        androidUrl = linkConfig.download.android.global || "";
      }
    }

    return { androidUrl };
  };

  getBrandName() {
    const { brandKey } = this.state;
    return brandNames[brandKey] || brandNames.wasin;
  }

  getLogoPath(ios) {
    const { brandKey } = this.state;
    return (ios && BRAND_LOGO_MAP[brandKey]) || BRAND_LOGO_MAP.wasin;
  }

  renderIOSDownload() {
    return (
      <div className={styles.ios_down}>
        <a
          href={this.state.iosUrl}
          className={classnames("flex-block active", styles.download_btn_store)}
        >
          <span className={styles.icon_ios}></span>
          <span className={styles.text}>{this.getBrandName()}</span>
          <span className={styles.icon}></span>
        </a>
      </div>
    );
  }

  renderAndroidDownload() {
    return (
      <a
        href={this.state.androidUrl}
        className={classnames("flex-block active", styles.download_btn, {
          [styles.loading]: this.state.loading,
        })}
      >
        {this.state.title}
      </a>
    );
  }

  render() {
    const ios = isIOS();
    const brandName = this.getBrandName();
    return (
      <BaseLayout>
        <div className={classnames("full-screen", styles.download)}>
          <WeixinMask />
          <h2>顶尖平台 卓越体验</h2>
          <p className={styles.summary}>操作简单易用，随时随地交易</p>
          <div
            className={styles.animate}
            style={{ backgroundImage: `url("${this.getLogoPath(ios)}")` }}
          />
          <h3>下载 {brandName} APP</h3>
          <p className={styles.strength}>
            <span>开放</span>
            <span>创新</span>
            <span>安全</span>
            <span>可信</span>
          </p>
          <div className={styles.download_wrapper}>
            <div className="flex-container flex-center">
              {ios ? this.renderIOSDownload() : this.renderAndroidDownload()}
            </div>
          </div>
          <footer className="tips">
            © Copyrights © {new Date().getFullYear()} {brandName} 版权所有{" "}
          </footer>
        </div>
      </BaseLayout>
    );
  }
}

export default Download;
